export default "__VITE_ASSET__CpV8aAu$__"